import styled from "styled-components";
import { Link } from "react-scroll";
import { ReactComponent as FacebookIconLink } from "../SvgIcons/facebookIcon.svg";
import { ReactComponent as InstagramIconLink } from "../SvgIcons/instagramIcon.svg";
import { ReactComponent as BookingIconLink } from "../SvgIcons/bookingIcon.svg";
import { ReactComponent as HomeIcon } from "./home_icon.svg";
import { ReactComponent as Logo } from "./logo_CMYK_kolor.svg";
import { Link as RouterLink } from "react-router-dom";


export const Navbar = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px); 
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

        @media (max-width: 1217px) {
        height: 60px;
        background-color: white;
        backdrop-filter: none;
  }
`;

export const NavWrapper = styled.div`
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
`;

export const NavLogo = styled(Logo)`
    height: 85px;
    width: 85px;
    cursor: pointer;
    margin-top: 4px;

    @media (max-width: 1217px) {
         height: 50px;
         width: 50px;
         margin-top: 4px;
    }
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 20px;
  margin-left: 20px;
  align-items: center;

   @media (max-width: 1217px) {
        display: none;
  }
`;

export const NavItem = styled(Link)`
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  color: white;
  text-decoration: none;
  transition: color 0.2s ease;
  text-transform: uppercase;
  text-align: center;
  transition: transform 0.3s ease, color 0.3s;

     @media (max-width: 1217px) {
        color: black;
        font-size: 20px;
        width: 100%;
        display: block;
        padding: 6px 0;
        text-align: center;
  }

  &:hover {
    color:rgb(221, 221, 221);

         @media (max-width: 1217px) {
            color:rgb(107, 107, 107);
  }
  }
`;

export const Burger = styled.button`
    display: none;
    position: relative;
    width: 44px;
    height: 44px;
    border: 0;
    background: transparent;
    cursor: pointer;
    padding: 0;

  @media (max-width: 1217px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  span {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 30px;
    height: 3px;
    background: black;
    border-radius: 2px;
    transform-origin: center;
    transition: transform 250ms ease, opacity 200ms ease;
  }

  span:nth-child(1) {
    transform: ${({ $open }) =>
    $open
      ? "translate(-50%, -50%) rotate(45deg)"
      : "translate(-50%, calc(-50% - 10px))"};
  }

  span:nth-child(2) {
    transform: translate(-50%, -50%);
    opacity: ${({ $open }) => ($open ? 0 : 1)};
  }

  span:nth-child(3) {
    transform: ${({ $open }) =>
    $open
      ? "translate(-50%, -50%) rotate(-45deg)"
      : "translate(-50%, calc(-50% + 10px))"};
  }
`;

export const MobileMenu = styled.div`
  display: none;

  @media (max-width: 1217px) {
    display: flex;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    flex-direction: column;
    align-items: center;
    background-color: white;
    padding: 10px 10px;
    padding-bottom: 20px;
    gap: 10px;
    z-index: 999;
    transform-origin: top;
    transform: ${({ $open }) => ($open ? "scaleY(1)" : "scaleY(0)")};
    opacity: ${({ $open }) => ($open ? 1 : 0)};
    transition: transform 260ms ease, opacity 200ms ease;
    pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  }
`;

export const NavIcons = styled.div`
    color: white;
    display: flex;
    gap: 10px;
    align-items: center;

      a:hover {
        color: rgb(221, 221, 221);
      }

      @media (max-width: 1217px) {
        display: none;
      }
`;

export const MobileNavIcons = styled.div`
    color: #7d966d;
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const SocialLinkIcon = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: inherit;
    text-decoration: none;

      &:visited,
      &:active {
        color: inherit;
      }
`;

export const FacebookIcon = styled(FacebookIconLink)`
    width: 48px;
    height: 48px;
    transition: transform 0.3s ease, color 0.3s;

        &:hover {
        transform: scale(1.05);
    }
`;

export const InstagramIcon = styled(InstagramIconLink)`
    width: 48px;
    height: 48px;
    transition: transform 0.3s ease, color 0.3s;

        &:hover {
        transform: scale(1.05);
    }
`;

export const BookingIcon = styled(BookingIconLink)`
    width: 48px;
    height: 48px;
    transition: transform 0.3s ease, color 0.3s;

        &:hover {
        transform: scale(1.05);
    }
`;

export const LangSwitch = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

    @media (max-width: 1217px) {
      gap: 3px;
    }
`;

export const LangBtn = styled.button`
  border: 0;
  background: transparent;
  color: white;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 6px 8px;
  border-radius: 10px;
  transition: transform 0.15s ease, background 0.15s ease, opacity 0.15s ease;

  opacity: ${({ $active }) => ($active ? 1 : 0.6)};
  background: ${({ $active }) => ($active ? "rgba(0,0,0,0.08)" : "transparent")};

    @media (max-width: 1217px) {
      color: black;
  }

  &:hover {
  transform: scale(1.05);
  opacity: 1;
}

  &:active {
  transform: scale(0.98);
}
`;

export const NavRouterItem = styled(RouterLink)`
  font-size: 16px;
  cursor: pointer;
  color: white;
  text-decoration: none;
  transition: color 0.2s ease;
  text-transform: uppercase;
  text-align: center;
  transition: transform 0.3s ease, color 0.3s;

     @media (max-width: 1217px) {
        color: black;
        font-size: 20px;
        width: 100%;
        display: block;
        padding: 6px 0;
        text-align: center;
  }

  &:hover {
    color:rgb(221, 221, 221);

         @media (max-width: 1217px) {
            color:rgb(107, 107, 107);
  }
  }
`;

export const CenterFlex = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const HomeIconSvg = styled(HomeIcon)`
  width: 16px;
  height: 16px;
`;

export const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;